// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.escalation {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-size: 14px;
  background: #f5f7fa;
  color: #333;
  overflow-y: hidden;
  letter-spacing: normal;
}

.escalation .page-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 20px;
}

.escalation .card {
  background: var(--color-white);
  border-radius: 6px;
  padding: 0px !important;
  margin-bottom: 20px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.escalation .card-header{
  border-bottom: 2px solid var(--color-primary-orange);
  font-size: 1rem;
  font-weight: 600;
  
} 

.escalation .card-title {
  font-size: 18px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 2px solid #e9ecef;
}

.escalation .form-label {
  color: #495057;
  font-weight: 500;
  margin-bottom: 8px;
}


/* action section css start */

.escalation .actions-section {
  font-family: "Segoe UI", sans-serif;
}

/* Make sure both sides (left & right dropdown/input) stay aligned */
.escalation .action-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.escalation .action-number {
  width: 26px;
  height: 26px;
  background-color: #16a34a;
  color: var(--color-white);
  font-weight: 600;
  font-size: 0.8rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.escalation .action-field .dropdown-select,
.escalation .action-value .dropdown-select,
.escalation .action-input {
  width: 100% !important;
  height: 38px !important;
  font-size: 0.9rem;
  border-radius: 6px;
}

/* Ensure all dropdowns and inputs look identical in width and height */
.escalation .action-field,
.escalation .action-value {
  flex: 1 1;
  min-width: 260px; /* gives consistent base width */
}
.escalation .cursor-pointer {
  cursor: pointer;
}

/* Prevent Bootstrap from shrinking smaller dropdowns */
.escalation .action-row .flex-grow-1 {
  flex-grow: 1 !important;
  flex-basis: 0 !important;
}

/* For consistent spacing on "Edit" and "Delete" */
.escalation .action-actions {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  white-space: nowrap;
}
.escalation .action-icon {
  font-size: 20px;
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.escalation .actions-section select,
.escalation .actions-section input,
.escalation .actions-section .form-control {
  height: 36px !important;
  border-radius: 8px !important;
  font-size: 0.9rem;
}

.escalation .actions-section .Dropdown-root {
  width: 548px !important;
}
.escalation .actions-section .text-danger.small {
  font-size: 0.85rem;
  margin-left: 3rem; 
}
/* action section css end */


/* condition section css start */
/* small helpers for the group colors */
.escalation .border-purple { border-color: #9c27b0 !important; }
.escalation .text-purple   { color: #9c27b0 !important; }
.escalation .bg-purple     { background-color: #9c27b0 !important; }
 
.escalation .border-orange { border-color: var(--color-primary-orange) !important; }
.escalation .text-orange   { color: var(--color-primary-orange) !important; }
.escalation .bg-orange     { background-color: var(--color-primary-orange) !important; }
 
/* group badge style */
.escalation .group-badge {
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
}
 
/* connector pill shown in summary (non-editable) */
.escalation .connector-pill {
  display: inline-block;
  margin-left: 8px;
  margin-right: 8px;
  background: #fff8e1;
  border: 2px solid #ffc107;
  color: #111;
  padding: 4px 10px;
  border-radius: 20px;
  font-weight: 600;
}
 
/* connector dropdown centered between group cards */
.escalation .connector-container { display:flex; justify-content:center; }
.escalation .logic-dropdown {
  border: 2px solid #ffc107 !important;
  border-radius: 20px !important;
  padding: 2px 12px !important;
  width: 90px;
  font-weight: 600;
  background-color: #fff8e1 !important;
  text-align: center;
}
 
/* small active conditions box visuals */
.escalation .active-conditions .badge { font-size: 12px; }
.escalation .active-conditions { display:flex; align-items:center; flex-wrap:wrap; gap: 8px; }
 
/* responsive spacing */
@media (max-width: 768px) {
  .escalation .condition-group .row > * { margin-bottom: 8px; }
  .escalation .logic-dropdown { width: 70px; padding: 2px 8px; }
}

/* condition section css end */

/*  Rule configue css start  */

  .escalation .form-textarea-field .col-2,
  .escalation .form-textarea-field .col-10 {
    flex: 0 0 100% !important;
    max-width: 100% !important;
  }

/*  Rule configue css end  */`, "",{"version":3,"sources":["webpack://./src/containers/vision_hub/escalation_rule_builder/EscalationRuleBuilder.css"],"names":[],"mappings":"AAAA;EACE,4DAA4D;EAC5D,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,oDAAoD;EACpD,eAAe;EACf,gBAAgB;;AAElB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;;AAGA,6BAA6B;;AAE7B;EACE,mCAAmC;AACrC;;AAEA,oEAAoE;AACpE;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;;EAGE,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,uEAAuE;AACvE;;EAEE,SAAO;EACP,gBAAgB,EAAE,gCAAgC;AACpD;AACA;EACE,eAAe;AACjB;;AAEA,uDAAuD;AACvD;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA,kDAAkD;AAClD;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;;;EAGE,uBAAuB;EACvB,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA,2BAA2B;;;AAG3B,gCAAgC;AAChC,uCAAuC;AACvC,6BAA6B,gCAAgC,EAAE;AAC/D,6BAA6B,yBAAyB,EAAE;AACxD,6BAA6B,oCAAoC,EAAE;;AAEnE,6BAA6B,oDAAoD,EAAE;AACnF,6BAA6B,6CAA6C,EAAE;AAC5E,6BAA6B,wDAAwD,EAAE;;AAEvF,sBAAsB;AACtB;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,mDAAmD;AACnD;EACE,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,oDAAoD;AACpD,mCAAmC,YAAY,EAAE,sBAAsB,EAAE;AACzE;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,4BAA4B;EAC5B,WAAW;EACX,gBAAgB;EAChB,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA,wCAAwC;AACxC,wCAAwC,eAAe,EAAE;AACzD,iCAAiC,YAAY,EAAE,kBAAkB,EAAE,cAAc,EAAE,QAAQ,EAAE;;AAE7F,uBAAuB;AACvB;EACE,wCAAwC,kBAAkB,EAAE;EAC5D,8BAA8B,WAAW,EAAE,gBAAgB,EAAE;AAC/D;;AAEA,8BAA8B;;AAE9B,8BAA8B;;EAE5B;;IAEE,yBAAyB;IACzB,0BAA0B;EAC5B;;AAEF,4BAA4B","sourcesContent":[".escalation {\r\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n  font-size: 14px;\r\n  background: #f5f7fa;\r\n  color: #333;\r\n  overflow-y: hidden;\r\n  letter-spacing: normal;\r\n}\r\n\r\n.escalation .page-container {\r\n  max-width: 1400px;\r\n  margin: 0 auto;\r\n  padding: 20px;\r\n}\r\n\r\n.escalation .card {\r\n  background: var(--color-white);\r\n  border-radius: 6px;\r\n  padding: 0px !important;\r\n  margin-bottom: 20px;\r\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.escalation .card-header{\r\n  border-bottom: 2px solid var(--color-primary-orange);\r\n  font-size: 1rem;\r\n  font-weight: 600;\r\n  \r\n} \r\n\r\n.escalation .card-title {\r\n  font-size: 18px;\r\n  font-weight: 600;\r\n  color: #2c3e50;\r\n  margin-bottom: 20px;\r\n  padding-bottom: 10px;\r\n  border-bottom: 2px solid #e9ecef;\r\n}\r\n\r\n.escalation .form-label {\r\n  color: #495057;\r\n  font-weight: 500;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n\r\n/* action section css start */\r\n\r\n.escalation .actions-section {\r\n  font-family: \"Segoe UI\", sans-serif;\r\n}\r\n\r\n/* Make sure both sides (left & right dropdown/input) stay aligned */\r\n.escalation .action-row {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.escalation .action-number {\r\n  width: 26px;\r\n  height: 26px;\r\n  background-color: #16a34a;\r\n  color: var(--color-white);\r\n  font-weight: 600;\r\n  font-size: 0.8rem;\r\n  border-radius: 50%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.escalation .action-field .dropdown-select,\r\n.escalation .action-value .dropdown-select,\r\n.escalation .action-input {\r\n  width: 100% !important;\r\n  height: 38px !important;\r\n  font-size: 0.9rem;\r\n  border-radius: 6px;\r\n}\r\n\r\n/* Ensure all dropdowns and inputs look identical in width and height */\r\n.escalation .action-field,\r\n.escalation .action-value {\r\n  flex: 1;\r\n  min-width: 260px; /* gives consistent base width */\r\n}\r\n.escalation .cursor-pointer {\r\n  cursor: pointer;\r\n}\r\n\r\n/* Prevent Bootstrap from shrinking smaller dropdowns */\r\n.escalation .action-row .flex-grow-1 {\r\n  flex-grow: 1 !important;\r\n  flex-basis: 0 !important;\r\n}\r\n\r\n/* For consistent spacing on \"Edit\" and \"Delete\" */\r\n.escalation .action-actions {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.75rem;\r\n  white-space: nowrap;\r\n}\r\n.escalation .action-icon {\r\n  font-size: 20px;\r\n  line-height: 1;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n.escalation .actions-section select,\r\n.escalation .actions-section input,\r\n.escalation .actions-section .form-control {\r\n  height: 36px !important;\r\n  border-radius: 8px !important;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.escalation .actions-section .Dropdown-root {\r\n  width: 548px !important;\r\n}\r\n.escalation .actions-section .text-danger.small {\r\n  font-size: 0.85rem;\r\n  margin-left: 3rem; \r\n}\r\n/* action section css end */\r\n\r\n\r\n/* condition section css start */\r\n/* small helpers for the group colors */\r\n.escalation .border-purple { border-color: #9c27b0 !important; }\r\n.escalation .text-purple   { color: #9c27b0 !important; }\r\n.escalation .bg-purple     { background-color: #9c27b0 !important; }\r\n \r\n.escalation .border-orange { border-color: var(--color-primary-orange) !important; }\r\n.escalation .text-orange   { color: var(--color-primary-orange) !important; }\r\n.escalation .bg-orange     { background-color: var(--color-primary-orange) !important; }\r\n \r\n/* group badge style */\r\n.escalation .group-badge {\r\n  padding: 4px 8px;\r\n  border-radius: 4px;\r\n  font-size: 12px;\r\n}\r\n \r\n/* connector pill shown in summary (non-editable) */\r\n.escalation .connector-pill {\r\n  display: inline-block;\r\n  margin-left: 8px;\r\n  margin-right: 8px;\r\n  background: #fff8e1;\r\n  border: 2px solid #ffc107;\r\n  color: #111;\r\n  padding: 4px 10px;\r\n  border-radius: 20px;\r\n  font-weight: 600;\r\n}\r\n \r\n/* connector dropdown centered between group cards */\r\n.escalation .connector-container { display:flex; justify-content:center; }\r\n.escalation .logic-dropdown {\r\n  border: 2px solid #ffc107 !important;\r\n  border-radius: 20px !important;\r\n  padding: 2px 12px !important;\r\n  width: 90px;\r\n  font-weight: 600;\r\n  background-color: #fff8e1 !important;\r\n  text-align: center;\r\n}\r\n \r\n/* small active conditions box visuals */\r\n.escalation .active-conditions .badge { font-size: 12px; }\r\n.escalation .active-conditions { display:flex; align-items:center; flex-wrap:wrap; gap: 8px; }\r\n \r\n/* responsive spacing */\r\n@media (max-width: 768px) {\r\n  .escalation .condition-group .row > * { margin-bottom: 8px; }\r\n  .escalation .logic-dropdown { width: 70px; padding: 2px 8px; }\r\n}\r\n\r\n/* condition section css end */\r\n\r\n/*  Rule configue css start  */\r\n\r\n  .escalation .form-textarea-field .col-2,\r\n  .escalation .form-textarea-field .col-10 {\r\n    flex: 0 0 100% !important;\r\n    max-width: 100% !important;\r\n  }\r\n\r\n/*  Rule configue css end  */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
